// extracted by css-extract-rspack-plugin
export default {"headerContainer":"_38879ba9","large":"_d0d67fcc","larger":"_2a9937de","title":"_3f802131","collectionTitle":"_585e61a7"};